<template>
  <div>
    <Banner :with-bias-banner="true" />
    <div style="position: relative; background-color: black; height: 54px; box-sizing: border-box;">
      <BiasFx2Banner />
    </div>
    <section class="mobile-licenses">
      <table>
        <tr>
          <th
            scope="col"
            colspan="1"
          />
          <th scope="col">
            BIAS FX2
            <br>
            <span style="color: white;">标准版</span>
          </th>
          <th scope="col">
            BIAS FX2
            <br>
            <span style="color: white;">专业版</span>
          </th>
          <th scope="col">
            BIAS FX2
            <br>
            <span style="color: white;">精英版</span>
          </th>
        </tr>
        <tr>
          <td style="font-size: 24px; color: #fdcb76;">
            特性
          </td>
          <td />
          <td />
          <td />
        </tr>
        <tr>
          <td>音频插件版本</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>独立版本</td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>厂家预置音色</td>
          <td>70</td>
          <td>130</td>
          <td>210</td>
        </tr>
        <tr>
          <td>音箱</td>
          <td>30</td>
          <td>60</td>
          <td>100</td>
        </tr>
        <tr>
          <td>效果器</td>
          <td>43</td>
          <td>115</td>
          <td>122</td>
        </tr>
        <tr>
          <td>机架</td>
          <td>-</td>
          <td>14</td>
          <td>18</td>
        </tr>
        <tr>
          <td>新的三重合唱HD机架</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的多段压缩HD机架</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的哇音HD机架</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的大型多点式延时HD机架</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的高级压缩HD机架</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的EchoreX延时HD机架</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的复古弹簧混响HD机架</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>新的莱斯利旋转扬声器HD机架</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>法兹建模效果器</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>时间建模效果器</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>和声建模效果器</td>
          <td>-</td>
          <td>-</td>
          <td class="circle">
            <span class="circle" />
          </td>
        </tr>
        <tr>
          <td>吉他匹配功能中的目标型号</td>
          <td>4</td>
          <td>8</td>
          <td>20</td>
        </tr>
        <tr>
          <td>循环录音机/伴奏播放器</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>MIDI/自动化</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>IR加载器</td>
          <td>-</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr />
        <tr>
          <td>新的音色云</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>新的用户界面和工作流程</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
        <tr>
          <td>新的DSP引擎</td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
          <td class="circle">
            <span />
          </td>
        </tr>
      </table>
    </section>
    <section class="expansion">
      <h2>系统需求</h2>
      <hr>
      <table>
        <tr>
          <td>最低需求（Mac）</td>
          <td>
            <ul>
              <li>OS X 10.11或更高版本</li>
              <li>最少4GB内存，建议8GB或更多</li>
              <li>音频插件格式：Audio Units, VST 2, AAX Native</li>
              <li>1GB可用磁盘空间</li>
              <li>需要网络连接来激活您的授权并访问音色云。目前Positive Grid软件产品不支持离线激活。只有在软件激活之后才有离线模式可用。</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>最低需求（PC）</td>
          <td>
            <ul>
              <li>Windows 8或更高版本</li>
              <li>最少4GB内存，建议8GB或更多</li>
              <li>最低1.5GHz双核处理器，建议2.0GHz双核或更高的处理器</li>
              <li>音频插件格式：VST 2, AAX Native</li>
              <li>500MB可用磁盘空间（32或64位版本）</li>
              <li>需要网络连接来激活您的授权并访问音色云。目前Positive Grid软件产品不支持离线激活。只有在软件激活之后才有离线模式可用。"</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>兼容的数字音频工作站</td>
          <td>
            <ul>
              <table class="daws">
                <tr>
                  <td>Ableton Live</td>
                  <td>8.0 或更高版本</td>
                </tr>
                <tr>
                  <td>Avid Pro Tools</td>
                  <td>11或更高版本</td>
                </tr>
                <tr>
                  <td>Apple Logic Pro</td>
                  <td>9.0或更高版本</td>
                </tr>
                <tr>
                  <td>Apple GarageBand</td>
                  <td>6.0.5, 10.0或更高版本</td>
                </tr>
                <tr>
                  <td>Cockos REAPER</td>
                  <td>3.4或更高版本</td>
                </tr>
                <tr>
                  <td>Steinberg Cubase</td>
                  <td>8.0或更高版本</td>
                </tr>
                <tr>
                  <td>Steinberg Nuendo</td>
                  <td>7.1.4或更高版本</td>
                </tr>
                <tr>
                  <td>PreSonus Studio One</td>
                  <td>Producer/Professional 2.65或更高版本</td>
                </tr>
                <tr>
                  <td>Propellerhead Reason</td>
                  <td>9.5或更高版本</td>
                </tr>
              </table>
            </ul>
          </td>
        </tr>
      </table>
    </section>
    <footer-weixin />
    <footer-common />
  </div>
</template>

<script>
import BiasFx2Banner from '@/components/bias-fx2-banner'
import BiasFxMobileSpec from '@/pages/bias-fx-mobile-spec'
import Banner from '@/components/banner'
import BiasFx2 from '@/pages/bias-fx2'

import FooterWeixin from '@/components/footer-weixin'
import FooterCommon from '@/components/footer-common'

import store from '@/store'

export default {
  name: 'Index',
  components: {
    Banner,
    FooterWeixin,
    FooterCommon,
    BiasFx2Banner
  },
  mixins: [BiasFx2, BiasFxMobileSpec],
  store,
  data () {
    return {}
  },
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/bias-fx2-spec.vue